import type { IntlShape } from 'react-intl/src/types';

import { type StockDisplay } from '@/views/WatchView/components/BookAppointmentModal/types';

import { messages } from './messages';

export const getStockDisplay = (
  formatMessage: IntlShape['formatMessage'],
  stock?: number | null,
): StockDisplay => {
  if (typeof stock === 'number' && !isNaN(stock)) {
    if (stock === 1) {
      return {
        color: 'warning',
        message: formatMessage(messages.onlyFewLeft),
      };
    }
    if (stock >= 1) {
      return {
        color: 'success',
        message: formatMessage(messages.available),
      };
    }
  }
  return {
    color: 'error',
    message: formatMessage(messages.lowAvailability),
  };
};
